module.exports = "varying vec2 f_uv;\r\nvarying vec3 f_normal;\r\nvarying vec3 f_position;\r\nvarying vec3 cameraPos;\r\n\r\n// uv, position, projectionMatrix, modelViewMatrix, normal\r\nvoid main() {\r\n    f_uv = uv;\r\n    f_normal = normal;\r\n    f_position = position;\r\n    cameraPos = cameraPosition;\r\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/iridiscence-vert.glsl
// module id = 12
// module chunks = 0